module.exports = __webpack_public_path__ + "img/background-branch-detail.903ca12f.svg";